import { baseEnvironment } from './environment.base';

export const environment = {
  ...baseEnvironment,
  application: {
    production: false,
  },
};
